export const HEADER_HEIGHT = 32;
/**
 * RowHeightType
 * Fixed: for fixed row height
 * Auto: the row height will be adjusted based on the content of the cell.
 */
export var RowHeightType;
(function (RowHeightType) {
    RowHeightType["Fixed"] = "fixed";
    RowHeightType["Auto"] = "auto";
})(RowHeightType || (RowHeightType = {}));
/**
 * RowHeight
 * Default: default row height for 2 lines of data, it will be 72 pixel
 * ThreeLines: It will fit the 3 lines of the data.
 * Extended: It will be extended to the content
 */
export var RowHeight;
(function (RowHeight) {
    RowHeight["Default"] = "default";
    RowHeight["ThreeLines"] = "threelines";
    RowHeight["Extended"] = "extended";
})(RowHeight || (RowHeight = {}));
/**
 * ColumnWidthType
 * Fixed: the fixed column width will not scaled on screen size or available space.
 * Fluid: the fluid column will be adjusted with the screen size or available space.
 */
export var ColumnWidthType;
(function (ColumnWidthType) {
    ColumnWidthType["Fixed"] = "fixed";
    ColumnWidthType["Fluid"] = "fluid";
})(ColumnWidthType || (ColumnWidthType = {}));
/**
 * ColumnWidth
 * Large: for large columns like name,
 * Medium: for showing options
 * Small: for showing single option
 * ExtraSmall: mostly used for icon columns
 */
export var ColumnWidth;
(function (ColumnWidth) {
    ColumnWidth[ColumnWidth["Large"] = 320] = "Large";
    ColumnWidth[ColumnWidth["Medium"] = 160] = "Medium";
    ColumnWidth[ColumnWidth["Small"] = 80] = "Small";
    ColumnWidth[ColumnWidth["ExtraSmall"] = 40] = "ExtraSmall";
})(ColumnWidth || (ColumnWidth = {}));
export var ColumnFilterType;
(function (ColumnFilterType) {
    ColumnFilterType["List"] = "list";
    ColumnFilterType["Date"] = "date";
})(ColumnFilterType || (ColumnFilterType = {}));
export var ColumnSort;
(function (ColumnSort) {
    ColumnSort["Asc"] = "ASC";
    ColumnSort["Desc"] = "DESC";
})(ColumnSort || (ColumnSort = {}));
//# sourceMappingURL=object-table.interface.js.map